import { Container } from "./style"

const TitlePages = ({text}) => {

    return(
        <Container>
          {text}
        </Container>
    )
}
export default TitlePages